export default "__VITE_ASSET__D9yA3o_1__"